<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<h1 class="booktitle"><a id="page7"></a>The Naked<br/>GOSPEL</h1>
<p class="othertext">The Truth You May Never Hear In Church</p>
<h3 class="author">Andrew Farley<br/><br/><br/><br/><br/><br/></h3>
<p class="publogo"><img alt="publisher logo" src="images/titl-logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004titlepage.vue?43eacde6